import { presetColors } from '@client/style/Variables';
import { TextStyle } from '@client/style/TextStyles';
import React from 'react';
import styled from 'styled-components';
import { useWholeHoursInRange } from './utils/useWholeHoursInRange';

const TimeIndicator = styled.div<{ $hours: number }>`
	top: 0px;
	height: 1.3em;
	border-bottom: 1px solid ${presetColors.blackish};
	z-index: 1;
	box-sizing: content-box;
	grid-row: 1;
	position: relative;
	padding-left: var(--gridMargin);
	display: grid;
	grid-template-columns: repeat(${props => props.$hours}, 1fr);
	grid-template-rows: max-content;
	align-content: start;
`;

const TimeEntries = styled.div`
	${TextStyle.family('title')}
	${TextStyle.size('xsmall')}
	line-height: 1.2;
`;

export default function DayTimeline({ from, to, hours }: { from: Date; to: Date; hours: number }) {
	const wholeHoursInRange = useWholeHoursInRange(from, to, hours);

	return (
		<TimeIndicator $hours={hours}>
			{wholeHoursInRange.map((time, i) => (
				<TimeEntries key={i}>
					{time.hour.toLocaleTimeString('Da-dk', {
						hour: '2-digit',
						minute: '2-digit',
						timeZone: 'Europe/Copenhagen',
					})}
				</TimeEntries>
			))}
		</TimeIndicator>
	);
}
